import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

/** Phase 7 #1 — reusable password field with a show/hide eye toggle, used
 * consistently everywhere a password is entered (login, signup, forgot
 * password, employee edit, settings). Hidden by default. */
const PasswordInput = React.forwardRef(({ className, "data-testid": testId, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        data-testid={testId}
        className={cn("pr-11", className)}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        data-testid={testId ? `${testId}-toggle-visibility` : undefined}
        aria-label={visible ? "Hide password" : "Show password"}
        className="absolute right-0 top-0 h-full w-11 grid place-items-center text-slate-400 hover:text-slate-600"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
